import { render, staticRenderFns } from "./attestation.vue?vue&type=template&id=0b8575ac&scoped=true&"
import script from "./attestation.vue?vue&type=script&lang=js&"
export * from "./attestation.vue?vue&type=script&lang=js&"
import style0 from "./attestation.vue?vue&type=style&index=0&id=0b8575ac&lang=scss&scoped=true&"
import style1 from "./attestation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8575ac",
  null
  
)

export default component.exports